




















































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import deck from '@/store/modules/deck';
import CompanySelection from '@/components/CompanySelection.vue';
import user from '@/store/modules/user';
import * as api from '@/store/api';
import alert from '@/store/modules/alert';
import { Subjects } from '@/components/simpleSlide/subject';
import Datepicker from 'vuejs-datepicker';
import { sv } from 'vuejs-datepicker/dist/locale';
import YearWheelEditor from '@/components/simpleSlide/components/YearWheelEditor.vue';
import ContentNotes from '@/services/ContentNotes';
import OrgChart from '@/components/OrgChart.vue';
import CustomDiagram from '@/components/simpleSlide/components/CustomDiagram.vue';
import TeamEditor from '@/components/simpleSlide/components/TeamEditor.vue';
import VisualContentEditor from '@/components/simpleSlide/components/VisualContentEditor.vue';
import AiInsightsEditor from '@/components/simpleSlide/components/AiInsightsEditor.vue';
import ContentTreePicker from '@/components/ContentTreePicker.vue';
import FinancialMentionField from '@/components/simpleSlide/components/FinancialMentionField.vue';
import { visibleMentionLength } from '@/components/simpleSlide/financialMentions';
import { getCollection } from '@/data/gt-library/registry';
import {
  contentTypes,
  ContentTypeEntry,
  ContentGroup,
  ContentLeaf,
  SlideDesign,
  isCompatible,
  matchesBrand,
  matchesAiInsightsEnabled,
  sortEntriesByCompatibility,
} from '@/components/simpleSlide/contentTypes';

@Component({
  computed: {
    Subjects() {
      return Subjects;
    },
  },
  components: {
    YearWheelEditor,
    CompanySelection,
    Datepicker,
    OrgChart,
    CustomDiagram,
    TeamEditor,
    VisualContentEditor,
    AiInsightsEditor,
    ContentTreePicker,
    FinancialMentionField,
  },
})
export default class ContentCreator extends Vue {
  @Prop() readonly slide: any;
  @Prop() readonly slideIndex!: number;
  @Prop({ default: false }) readonly hideTabs!: boolean;
  @Prop({ default: 'tabs' }) readonly designMode!: 'tabs' | 'full' | 'split';

  openGroupId: string | null = null;

  company: any = { label: '', value: '' };
  source: any = { label: '', value: '' };
  companyCompetitor1: any = { label: '', value: '' };
  companyCompetitor2: any = { label: '', value: '' };

  setChart: string = '';
  chart: string = '';

  isDragging: boolean = false;
  draggedIndex: null | number = null;
  draggedItemIndex: null | number = null;

  mounted() {
    this.loadCompany();
  }

  get lang() {
    return sv;
  }

  onTreeSelectedNodeIds(ids: string[] | undefined) {
    if (ids === undefined) {
      delete this.subSlide.selectedNodeIds;
    } else {
      this.subSlide.selectedNodeIds = ids;
    }
    this.update();
  }

  onTreeStartNodeId(id: string | undefined) {
    this.subSlide.startNodeId = id || this.subSlide.collectionId || 'services';
    this.update();
  }

  toggleSubject(subject: any) {
    if (!this.subSlide.subjects) {
      this.subSlide.subjects = [];
    }
    if (this.isSubjectSelected(subject)) {
      this.subSlide.subjects = this.subSlide.subjects.filter(
        (id: any) => id !== subject.id,
      );
    } else {
      if (this.subSlide.subjects.length >= 5) {
        return;
      }
      this.subSlide.subjects.push(subject.id);

      // Lägg till anteckning endast när ett subject väljs och det inte redan finns en anteckning
      if (
        ContentNotes.hasDefaultNote('contentLibrary', subject.id) &&
        (!this.subSlide.note || this.subSlide.note === '')
      ) {
        this.subSlide.note = ContentNotes.getDefaultNote(
          'contentLibrary',
          subject.id,
        );
        this.$root.$emit('deck:noteUpdated');
      }
    }
    this.update();
  }

  isSubjectSelected(subject: any) {
    if (!this.subSlide.subjects) {
      return false;
    }
    return this.subSlide.subjects.find((id: any) => id === subject.id);
  }

  async loadCompany() {
    if (
      this.contentType !== 'contentChart' &&
      this.contentType !== 'contentTable' &&
      this.contentType !== 'contentDiagram' &&
      this.contentType !== 'customDiagram'
    ) {
      this.company = { label: '', value: '' };
      return;
    }

    if (this.subSlide.competitor1) {
      const c1 = await user.getCompany(this.subSlide.competitor1);
      if (!c1) {
        this.companyCompetitor1 = { label: '', value: '' };
        return;
      }
      this.companyCompetitor1 = {
        value: c1.OrgNr,
        label: c1.Name,
        dateTo: c1.DateTo,
        SieAggVersion: 0,
      };
    } else {
      this.companyCompetitor1 = { label: '', value: '' };
    }

    if (this.subSlide.competitor2) {
      const c2 = await user.getCompany(this.subSlide.competitor2);
      if (!c2) {
        this.companyCompetitor2 = { label: '', value: '' };
        return;
      }
      this.companyCompetitor2 = {
        value: c2.OrgNr,
        label: c2.Name,
        dateTo: c2.DateTo,
        SieAggVersion: 0,
      };
    } else {
      this.companyCompetitor2 = { label: '', value: '' };
    }

    const orgNr = this.subSlide.OrgNr || deck.OrgNr;
    const sieAggVersion = this.activeSieAggVersion();

    if (orgNr === '00' || orgNr === '') {
      this.company = { label: '', value: '' };
      return;
    }

    if (
      this.company &&
      this.company.value === orgNr &&
      this.company.SieAggVersion === sieAggVersion
    ) {
      return;
    }

    const c = await user.getCompany(orgNr);
    if (!c) {
      this.company = { label: '', value: '' };
      return;
    }

    this.company = {
      value: c.OrgNr,
      label: c.Name,
      dateTo: c.DateTo,
      Branch: this.subSlide.Branch || c.Bransch,
      BranchText: this.subSlide.BranchText || c.BranschText,
      SieAggVersion: sieAggVersion,
    };
  }

  activeSieAggVersion() {
    if (this.subSlide.OrgNr) {
      return this.subSlide.SieAggVersion;
    }
    return deck.SieAggVersion;
  }

  get isSie() {
    return this.activeSieAggVersion() > 0;
  }

  companyUpdated(company: any) {
    if (!company) {
      delete this.subSlide.OrgNr;
      delete this.subSlide.SieAggVersion;
    } else if (company.value === '') {
      return;
    } else {
      this.company = company;
    }
  }

  sourceUpdated(source: any) {
    if (source && source.id === 0) {
      if (this.subSlide.chart === 'sustainabilityCompass') {
        this.subSlide.chart = '';
      }
    }

    if (!this.company && !source) {
      this.loadCompany();
    }

    if (
      this.company === null ||
      (deck.OrgNr === this.company.value && deck.SieAggVersion === source.id)
    ) {
      delete this.subSlide.OrgNr;
      delete this.subSlide.SieAggVersion;
      this.update();
    } else if (
      this.subSlide.OrgNr !== this.company.value ||
      this.subSlide.SieAggVersion !== source.id
    ) {
      this.subSlide.OrgNr = this.company.value;
      this.subSlide.SieAggVersion = source.id;
      this.company.SieAggVersion = source.id;
      this.update();
    }
  }

  branchUpdated(branch: any) {
    this.subSlide.Branch = branch.id;
    this.subSlide.BranchText = branch.label;
    this.update();
  }

  competitor1Updated(competitor1: any) {
    if (!competitor1) {
      delete this.subSlide.competitor1;
      this.update();
    } else if (competitor1.value === '') {
      return;
    } else if (this.subSlide.competitor1 !== competitor1.value) {
      this.subSlide.competitor1 = competitor1.value;
      this.update();
    }
  }

  competitor2Updated(competitor2: any) {
    if (!competitor2) {
      delete this.subSlide.competitor2;
      this.update();
    } else if (competitor2.value === '') {
      return;
    } else if (this.subSlide.competitor2 !== competitor2.value) {
      this.subSlide.competitor2 = competitor2.value;
      this.update();
    }
  }

  setCurrentSubSlide(index: number) {
    deck.setCurrentSubSlide(index);
    this.$root.$emit('deck:currentSubSlideChanged');
  }

  get currentSubSlide() {
    return deck.nav.currentSubSlide;
  }

  get currentTab() {
    let cnt = 0;
    for (let i = 0; i < this.currentSubSlide; i++) {
      if (this.slide.subSlides[i].description === '') {
        continue;
      }
      cnt++;
    }
    return cnt + 1;
  }

  get tabCount() {
    const cnt = this.slide.subSlides.filter((s: any) => s.description !== '')
      .length;
    if (this.subSlide.description === '') {
      return cnt + 1;
    }
    return cnt;
  }

  @Watch('currentSubSlide')
  onCurrentSubSlideChanged() {
    this.loadCompany();
    this.openGroupId = null;
  }

  @Watch('contentType')
  onContentTypeChanged() {
    this.loadCompany();
  }

  get subSlide() {
    return this.slide.subSlides[this.currentSubSlide];
  }

  get mentionCompanyData(): any | null {
    const orgNr =
      (this.subSlide && this.subSlide.OrgNr) || deck.OrgNr;
    if (!orgNr || orgNr === '00') {
      return null;
    }
    const sie =
      (this.subSlide && this.subSlide.SieAggVersion != null
        ? this.subSlide.SieAggVersion
        : deck.SieAggVersion) || 0;
    const byOrg = deck.Data && deck.Data[orgNr];
    if (!byOrg) {
      return null;
    }
    return byOrg[sie] || byOrg[0] || null;
  }

  get textVisibleLength(): number {
    return visibleMentionLength(
      (this.subSlide && this.subSlide.text) || '',
      this.mentionCompanyData,
    );
  }

  listItemVisibleLength(index: number): number {
    const items = (this.subSlide && this.subSlide.items) || [];
    return visibleMentionLength(items[index] || '', this.mentionCompanyData);
  }

  onTextMention(value: string) {
    this.subSlide.text = value;
    this.update();
  }

  onListItemMention(index: number, value: string) {
    this.$set(this.subSlide.items, index, value);
    this.update();
  }

  get contentType() {
    return this.subSlide.contentType;
  }

  get design(): SlideDesign {
    if (this.slide && this.slide.slideType === 'slideFullContent') {
      return 'slideFullContent';
    }
    if (this.slide && this.slide.slideType === 'splitContent') {
      return 'splitContent';
    }
    return 'slideContent';
  }

  get designLabel(): string {
    if (this.design === 'slideFullContent') {
      return 'Helsida';
    }
    if (this.design === 'splitContent') {
      return 'Delad sida';
    }
    return 'Fliksidor';
  }

  get isSplit(): boolean {
    return this.designMode === 'split';
  }

  get isTabs(): boolean {
    return this.designMode === 'tabs' && !this.hideTabs;
  }

  get currentPartLabel(): string {
    if (!this.isSplit) {
      return '';
    }
    return this.currentSubSlide === 0 ? 'vänstra' : 'högra';
  }

  get contentPageHeading(): string {
    switch (this.subSlide.contentType) {
      case 'contentList':
        return 'Skriv dina punkter:';
      case 'contentText':
        return 'Skriv din text här:';
      case 'contentChart':
      case 'contentTable':
        return 'Välj bolag:';
      case 'contentImage':
        return 'Vilken bild vill du använda?';
      case 'contentPdf':
        return 'Vilken PDF-fil vill du bädda in?';
      case 'contentSchedule':
        return 'Tidsplan:';
      case 'contentYearWheel':
        return 'Fyll i ditt Årshjul:';
      case 'customDiagram':
        return 'Skapa ditt eget diagram:';
      case 'contentTree': {
        const collection = getCollection(
          this.subSlide.collectionId || 'services',
        );
        return collection ? collection.name : 'Våra tjänster';
      }
      case 'contentMore':
        return this.brand() === 'gt'
          ? 'Grant Thorntons innehållsbibliotek:'
          : 'Vilken typ av innehåll vill du skapa?';
      case 'orgChart':
        return 'Bygg ditt koncernträd:';
      case 'contentLibrary':
        return (
          'Kategorin "' +
          Subjects.getCategory(this.subSlide.contentCategory) +
          '" innehåller följade sidor:'
        );
      case 'contentTeam':
      case 'contentVisual':
      case 'contentAiInsights':
        return 'Ange rubrik:';
      default:
        return '';
    }
  }

  get aiInsightsEnabled(): boolean {
    return !!user.user && user.user.AiInsightsEnabled === true;
  }

  get visibleTopLevelEntries(): ContentTypeEntry[] {
    const currentBrand = this.brand();
    const entries = contentTypes.filter((entry) =>
      matchesBrand(entry, currentBrand as any),
    );
    return sortEntriesByCompatibility(entries, this.design);
  }

  get visibleGroupChildren(): ContentLeaf[] {
    if (!this.currentGroup) {
      return [];
    }
    const currentBrand = this.brand();
    const enabled = this.aiInsightsEnabled;
    const children = this.currentGroup.children.filter(
      (child) =>
        matchesBrand(child, currentBrand as any) &&
        matchesAiInsightsEnabled(child, enabled),
    );
    return sortEntriesByCompatibility(children, this.design) as ContentLeaf[];
  }

  get currentGroup(): ContentGroup | null {
    if (!this.openGroupId) {
      return null;
    }
    const match = contentTypes.find(
      (e) => e.kind === 'group' && e.id === this.openGroupId,
    );
    return match && match.kind === 'group' ? match : null;
  }

  isEntryCompatible(entry: ContentTypeEntry): boolean {
    return isCompatible(entry, this.design);
  }

  onEntryClick(entry: ContentTypeEntry) {
    if (!this.isEntryCompatible(entry)) {
      return;
    }
    if (entry.kind === 'group') {
      this.openGroupId = entry.id;
      return;
    }
    this.setContentType(entry.id);
  }

  closeGroup() {
    this.openGroupId = null;
  }

  backToDesign() {
    this.$emit('back-to-design');
  }

  @Watch('slideIndex')
  onSlideIndexChangedResetGroup() {
    this.openGroupId = null;
  }

  async update() {
    await deck.updateSlideWithReload({
      slide: this.slide,
      index: this.slideIndex,
    });
    this.loadCompany();
  }

  setContentType(contentType: any, contentCategory: any = '') {
    switch (contentType) {
      case 'contentList':
        this.subSlide.contentType = 'contentList';
        this.subSlide.items = ['Punkt 1', 'Punkt 2', 'Punkt 3', '', ''];
        break;
      case 'contentChart':
        this.subSlide.contentType = 'contentChart';
        this.subSlide.chart = '';
        break;
      case 'customDiagram':
        this.subSlide.contentType = 'customDiagram';
        this.subSlide.diagramType = 'bar';
        this.subSlide.diagramTitle = '';
        this.subSlide.diagramUnit = '';
        this.subSlide.series1 = '';
        this.subSlide.series2 = '';
        this.subSlide.series3 = '';
        this.subSlide.categories = Array(12).fill('');
        this.subSlide.values1 = Array(12).fill(null);
        this.subSlide.values2 = Array(12).fill(null);
        this.subSlide.values3 = Array(12).fill(null);
        break;
      case 'contentTable':
        this.subSlide.contentType = 'contentTable';
        this.subSlide.table = '';
        break;
      case 'contentText':
        this.subSlide.contentType = 'contentText';
        this.subSlide.text = '';
        break;
      case 'contentImage':
        this.subSlide.contentType = 'contentImage';
        this.subSlide.name = '';
        this.subSlide.blobId = '';
        break;
      case 'contentPdf':
        this.subSlide.contentType = 'contentPdf';
        this.subSlide.name = '';
        this.subSlide.blobId = '';
        break;
      case 'contentMore':
        this.subSlide.contentType = 'contentMore';
        break;
      case 'contentTree': {
        const collectionId = contentCategory || 'services';
        this.subSlide.contentType = 'contentTree';
        this.subSlide.collectionId = collectionId;
        delete this.subSlide.selectedNodeIds;
        this.subSlide.startNodeId = collectionId;
        if (collectionId !== 'foretagspresentation-test') {
          deck.setNextStepsEnabled(true);
        }
        break;
      }
      case 'contentLibrary':
        this.subSlide.contentType = 'contentLibrary';
        this.subSlide.contentCategory = contentCategory;
        this.subSlide.subjects = [];
        break;
      case 'contentSchedule':
        this.subSlide.contentType = 'contentSchedule';
        this.subSlide.items = [
          { date: '', text: '' },
          { date: '', text: '' },
          { date: '', text: '' },
          { date: '', text: '' },
          { date: '', text: '' },
          { date: '', text: '' },
          { date: '', text: '' },
        ];
        break;
      case 'contentYearWheel':
        this.subSlide.contentType = 'contentYearWheel';
        break;
      case 'orgChart':
        this.subSlide.contentType = 'orgChart';
        this.subSlide.chartData = null;
        break;
      case 'contentTeam':
        this.subSlide.contentType = 'contentTeam';
        if (!this.subSlide.title) {
          this.subSlide.title = 'Ditt team';
        }
        if (!this.subSlide.teamMembers) {
          this.subSlide.teamMembers = [];
        }
        break;
      case 'contentVisual':
        this.subSlide.contentType = 'contentVisual';
        if (!this.subSlide.title) {
          this.subSlide.title = 'Rubrik';
        }
        if (!this.subSlide.teamMembers) {
          this.subSlide.teamMembers = [];
        }
        break;
      case 'contentAiInsights':
        this.subSlide.contentType = 'contentAiInsights';
        if (!this.subSlide.title) {
          this.subSlide.title = 'Insikter';
        }
        this.subSlide.OrgNr =
          deck.OrgNr && deck.OrgNr !== '00' ? deck.OrgNr : '';
        this.subSlide.selectedInsightIds = [];
        this.subSlide.insights = [];
        break;
      default:
        console.log('Unknown content type');
    }

    this.openGroupId = null;
    this.update();
    // this.$nextTick(() => this.$refs.tabName.select());
  }

  addTab() {
    this.slide.subSlides.push({ description: '', contentType: '' });
    this.setCurrentSubSlide(this.slide.subSlides.length - 1);
    this.update();
  }

  deleteTab(index: number) {
    this.slide.subSlides.splice(index, 1);
    this.update();
    this.setCurrentSubSlide(0);
  }

  duplicateTab() {
    if (this.slide.subSlides.length >= 4) {
      return;
    }
    const currentIndex = this.currentSubSlide;
    const currentSubSlide = this.subSlide;

    // Deep copy av den aktuella fliken
    const duplicatedSubSlide = JSON.parse(JSON.stringify(currentSubSlide));

    // Lägg till "(kopia)" i beskrivningen, men begränsa till max 20 tecken
    if (duplicatedSubSlide.description) {
      const copyText = ' (kopia)';
      const maxLength = 20;
      const availableLength = maxLength - copyText.length;
      if (duplicatedSubSlide.description.length > availableLength) {
        duplicatedSubSlide.description =
          duplicatedSubSlide.description.substring(0, availableLength) +
          copyText;
      } else {
        duplicatedSubSlide.description =
          duplicatedSubSlide.description + copyText;
      }
    }

    // Infoga den duplicerade fliken direkt efter den nuvarande
    this.slide.subSlides.splice(currentIndex + 1, 0, duplicatedSubSlide);

    // Växla till den nya duplicerade fliken
    this.setCurrentSubSlide(currentIndex + 1);

    // Uppdatera
    this.update();
  }

  findParentGroupId(contentTypeId: string): string | null {
    for (const entry of contentTypes) {
      if (
        entry.kind === 'group' &&
        entry.children.some((child) => child.id === contentTypeId)
      ) {
        return entry.id;
      }
    }
    return null;
  }

  clearContentFields() {
    if (this.subSlide.texts) {
      delete this.subSlide.texts;
    }
    delete this.subSlide.title;
    delete this.subSlide.teamMembers;
    delete this.subSlide.collectionId;
    delete this.subSlide.selectedNodeIds;
    delete this.subSlide.startNodeId;
    delete this.subSlide.contentCategory;
    delete this.subSlide.subjects;
    delete this.subSlide.insights;
    delete this.subSlide.selectedInsightIds;
  }

  goBackFromContent() {
    const previousType = this.subSlide.contentType;
    if (previousType === 'contentTree' || previousType === 'contentLibrary') {
      this.clearContentFields();
      this.subSlide.contentType = 'contentMore';
      this.openGroupId = null;
      this.update();
      return;
    }

    const parentGroupId = this.findParentGroupId(previousType);
    this.subSlide.contentType = '';
    this.clearContentFields();
    this.openGroupId = parentGroupId;
    deck.updateSlide({
      slide: this.slide,
      index: this.slideIndex,
    });
  }

  resetContent() {
    this.subSlide.contentType = '';
    this.clearContentFields();
    this.openGroupId = null;
    deck.updateSlide({
      slide: this.slide,
      index: this.slideIndex,
    });
  }

  brand() {
    if (process.env.VUE_APP_BRAND === 'GT') {
      return 'gt';
    }
    return 'demo';
  }

  onFileChange(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    if (!files.length) {
      return;
    }

    const me = this;
    const formData = new FormData();
    const input: any = files[0];

    formData.append('file', input);
    api
      .uploadBlob(formData)
      .then((response: any) => {
        // console.log(response);
        me.subSlide.name = input.name;
        me.subSlide.blobId = response.data;
        me.update();
      })
      .catch((error) => {
        const apiError = error.error.response.data;
        alert.setError(apiError);
      });
  }

  onNewFileChange(event: any) {
    const file = event.target.files[0];
    this.onFileChange({ target: { files: [file] } });
  }

  onDrop(event: any) {
    const file = event.dataTransfer.files[0];
    this.onFileChange({ target: { files: [file] } });
    this.isDragging = false;
  }
  onClick() {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onDragEnter() {
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  onDragStartTab(event: any, index: any) {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', index);
    this.draggedIndex = index;
  }

  onDragEnterTab(event: any, index: any) {
    if (index !== this.draggedIndex) {
      this.reorderTabs(this.draggedIndex, index);
      this.draggedIndex = index;
    }
  }

  onDragEndTab() {
    this.draggedIndex = null;
  }

  onDropTab(event: any, index: any) {
    event.preventDefault();
    this.draggedIndex = null;
  }

  reorderTabs(fromIndex: any, toIndex: any) {
    const movedTab = this.slide.subSlides.splice(fromIndex, 1)[0];
    this.slide.subSlides.splice(toIndex, 0, movedTab);

    this.setCurrentSubSlide(toIndex);
    this.update();

    // Skicka event att flikar har omordnats
    this.$root.$emit('deck:tabsReordered');
  }

  onDragStartItem(event: any, index: any) {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', index);
    this.draggedItemIndex = index;
  }

  onDragEnterItem(event: any, index: any) {
    if (index !== this.draggedItemIndex) {
      this.reorderItems(this.draggedItemIndex, index);
      this.draggedItemIndex = index;
    }
  }

  onDragEndItem() {
    this.draggedItemIndex = null;
  }

  onDropItem(event: any, index: any) {
    event.preventDefault();
    this.draggedItemIndex = null;
  }

  reorderItems(fromIndex: any, toIndex: any) {
    const movedItem = this.subSlide.items.splice(fromIndex, 1)[0];
    this.subSlide.items.splice(toIndex, 0, movedItem);
    this.update();
  }

  @Watch('subSlide.chart')
  onChartChanged(newValue: string, oldValue: string) {
    if (
      newValue &&
      newValue !== oldValue &&
      ContentNotes.hasDefaultNote('contentChart', newValue) &&
      (!this.subSlide.note || this.subSlide.note === '')
    ) {
      this.subSlide.note = ContentNotes.getDefaultNote(
        'contentChart',
        newValue,
      );
      this.update();
      this.$root.$emit('deck:noteUpdated');
    }
  }

  @Watch('subSlide.table')
  onTableChanged(newValue: string, oldValue: string) {
    if (
      newValue &&
      newValue !== oldValue &&
      ContentNotes.hasDefaultNote('contentTable', newValue) &&
      (!this.subSlide.note || this.subSlide.note === '')
    ) {
      this.subSlide.note = ContentNotes.getDefaultNote(
        'contentTable',
        newValue,
      );
      this.update();
      this.$root.$emit('deck:noteUpdated');
    }
  }
}
